'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CommerceApi = function (_BaseApi) {
  (0, _inherits3.default)(CommerceApi, _BaseApi);
  function CommerceApi() {
    (0, _classCallCheck3.default)(this, CommerceApi);
    return (0, _possibleConstructorReturn3.default)(this, (CommerceApi.__proto__ || Object.getPrototypeOf(CommerceApi)).call(this, _frontendUtils.endpoints.commerceBaseUrl));
  }
  (0, _createClass3.default)(CommerceApi, [{
    key: 'getSource',
    value: function getSource(sourceId) {
      if (!ValidationUtils.isGuid(sourceId)) {
        return Promise.reject(new _ParameterError2.default('sourceId', sourceId, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'merchants/commerceSource/' + sourceId
      });
    }
  }, {
    key: 'getSourceConfig',
    value: function getSourceConfig(sourceConfigId) {
      if (!ValidationUtils.isGuid(sourceConfigId)) {
        return Promise.reject(new _ParameterError2.default('sourceConfigId', sourceConfigId, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'merchants/commerceSourceConfiguration/' + sourceConfigId
      });
    }
  }, {
    key: 'createOrUpdateSource',
    value: function createOrUpdateSource(domain) {
      if (!ValidationUtils.isNonEmptyOrBlankString(domain)) {
        return Promise.reject(new _ParameterError2.default('domain', domain, 'string.'));
      }
      return this.makeRequest({
        method: 'PUT',
        url: 'merchants/commerceSource',
        body: {
          domain: domain
        }
      });
    }
  }, {
    key: 'createSourceConfig',
    value: function createSourceConfig(sourceId, countryCode, apiType, properties) {
      if (!ValidationUtils.isGuid(sourceId)) {
        return Promise.reject(new _ParameterError2.default('sourceId', sourceId, 'guid string.'));
      }
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString(countryCode))) {
        return Promise.reject(new _ParameterError2.default('countryCode', countryCode, 'string.'));
      }
      if (apiType !== 'RESOLVE_PRODUCT') {
        return Promise.reject(new _ParameterError2.default('apiType', apiType, 'one of ["RESOLVE_PRODUCT"].'));
      }
      if (!ValidationUtils.isObject(properties)) {
        return Promise.reject(new _ParameterError2.default('properties', properties, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'merchants/commerceSourceConfiguration',
        body: {
          commerceSourceId: sourceId,
          countryCode: countryCode,
          apiType: apiType,
          properties: properties
        }
      });
    }
  }, {
    key: 'updateSourceConfigStatus',
    value: function updateSourceConfigStatus(sourceConfigId, status) {
      if (!ValidationUtils.isGuid(sourceConfigId)) {
        return Promise.reject(new _ParameterError2.default('sourceConfigId', sourceConfigId, 'guid string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(status)) {
        return Promise.reject(new _ParameterError2.default('status', status, 'string.'));
      }
      return this.makeRequest({
        method: 'PATCH',
        url: 'merchants/commerceSourceConfiguration/' + sourceConfigId + '/status/' + status,
        headers: {
          'content-type': 'application/json'
        }
      });
    }
  }, {
    key: 'updateSourceConfigProperties',
    value: function updateSourceConfigProperties(sourceConfigId, properties) {
      if (!ValidationUtils.isGuid(sourceConfigId)) {
        return Promise.reject(new _ParameterError2.default('sourceConfigId', sourceConfigId, 'guid string.'));
      }
      if (!ValidationUtils.isObject(properties)) {
        return Promise.reject(new _ParameterError2.default('properties', properties, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'PATCH',
        url: 'merchants/commerceSourceConfiguration/' + sourceConfigId + '/properties',
        body: properties
      });
    }
  }, {
    key: 'resolveProduct',
    value: function resolveProduct(sourceId, product, webhook) {
      if (!ValidationUtils.isGuid(sourceId)) {
        return Promise.reject(new _ParameterError2.default('sourceId', sourceId, 'guid string.'));
      }
      if (!ValidationUtils.isObject(product)) {
        return Promise.reject(new _ParameterError2.default('product', product, 'javascript object.'));
      }
      if (!ValidationUtils.isObject(webhook)) {
        return Promise.reject(new _ParameterError2.default('webhook', webhook, 'javascript object.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'merchants/' + sourceId + '/resolve/product',
        body: {
          product: product,
          webhook: webhook
        }
      });
    }
  }]);
  return CommerceApi;
}(_BaseApi3.default);
exports.default = CommerceApi;